import Box from 'UIKit/Box/Box'
import Text from 'UIKit/Text'
import { RowCenter } from 'layout/Components/Row'
import styled from 'styled-components'

interface LiveWinBadgeProps {
  liveWinAmount: number
}

const LiveWinBadge: React.FC<LiveWinBadgeProps> = ({ liveWinAmount }) => {
  return (
    <StyledLiveBetIconContainer minWidth={36} minHeight={36} position="relative">
      {liveWinAmount > 0 ? (
        <StyledLiveBetAmountBadge>
          <Text fontSize="12px" bold>
            {liveWinAmount}
          </Text>
        </StyledLiveBetAmountBadge>
      ) : null}
    </StyledLiveBetIconContainer>
  )
}

const StyledLiveBetIconContainer = styled(RowCenter)`
  border-radius: 50%;
  position: absolute;
`

const StyledLiveBetAmountBadge = styled(Box)`
  border-radius: ${({ theme: { radii } }) => radii.small};
  background: ${({ theme: { colors } }) => colors.strokeAlt3};
  border: ${({ theme: { colors } }) => `1px solid ${colors.background}`};

  max-height: 36px;

  padding: 2px 6px;

  position: absolute;
  top: -4px;
  left: -15px;
  z-index: 2;
`

export default LiveWinBadge
